import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Layout from '@/layout'

export const baseRoutes = [{
	path: '/',
	redirect: "/start"
}, {
	path: '/login',
	component: () => import("@/views/login/index"),
	hidden: true
}, {
	path: '/start',
	component: () => import("@/views/start"),
	hidden: true
}, {
	path: '/404',
	component: () => import("@/views/404"),
	hidden: true
}, {
	path: '/500',
	component: () => import("@/views/500"),
	hidden: true
}, {
	path: '/doTheHomework',
	name: "doTheHomework",
	component: () => import("@/views/myClass/doTheHomework"),
	hidden: true
}, {
	path: '/testHomework',
	name: "testHomework",
	component: () => import("@/views/myClass/doTheHomework/components/gameRender"),
	hidden: true
}, {
	path: '/cEditor',
	name: "cEditor",
	component: () => import("@/views/cEditor"),
	hidden: true
}, {
	path: '/pyEditor',
	name: "pyEditor",
	component: () => import("@/views/pyEditor"),
	hidden: true
}, {
	path: "/problemInfo",
	name: "problemInfo",
	hidden: true,
	component: () => import("@/views/xinAoTraining/problemInfo"),
	meta: {
		title: "题目详情",
	}
}, {
	path: "/questionBank",
	name: "questionBank",
	hidden: true,
	component: () => import("@/views/preliminaryClassic/questionBank"),
	meta: {
		title: "题库选择",
	}
}, {
	path: "/makeAquestion",
	name: "makeAquestion",
	hidden: true,
	component: () => import("@/views/preliminaryClassic/makeAquestion"),
	meta: {
		title: "做题目",
	}
}, {
	path: "/competitionResult",
	name: "competitionResult",
	hidden: true,
	component: () => import("@/views/simulationGame/competitionResult/index"),
	meta: {
		title: "考试结果",
	}
}, {
	path: "/competition",
	name: "competition",
	hidden: true,
	component: () => import("@/views/simulationGame/competition/index"),
	meta: {
		title: "考试",
	}
}, {
	path: "/aiLink",
	name: "aiLink",
	component: () => import("@/views/aiTools/aiLink/index"),
	meta: {
		title: "AI工具",
	}
}]


const routes = [{
		path: "/",
		component: Layout,
		noDropdown: true,
		children: [{
			path: "/simulationGame",
			name: "simulationGame",
			component: () => import("@/views/simulationGame/index"),
			meta: {
				title: "考试",
				icon: "iconfont icon-monisai"
			}
		}]
	}
]

export const asyncRoutes = routes

//允许路由重复点击
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
	scrollBehavior: () => ({
		y: 0
	}),
	routes: baseRoutes
})

export function resetRouter() {
	router.matcher = new VueRouter({
		// mode: 'history',
		scrollBehavior: () => ({
			y: 0
		}),
		routes: baseRoutes
	}).matcher;
}

export default router
